import * as React from 'react';

import Box, { BoxStyle } from '../components/Box';
import Header from '../components/Header';
import { ButtonStyle } from '../components/Button';
import { ActionBar, ActionBarStyle } from '../components/ActionBar';

export default (props: any) => (
  <div className={BoxStyle.Padded}>
    <img
      src="/images/error.png"
      alt="Page Not Found"
      className="w4 h4 br-100 db ml-auto mr-auto mb3"
    />
    <Header
      title="Page Not Found"
      subtitle={
        "Sorry, we couldn't find this page. Please check the link or try one of the options below."
      }
    />
    <ActionBar
      className={ActionBarStyle.alignCenter}
      actions={[
        {
          className: ButtonStyle.Normal,
          label: 'Home Page',
          handler: () => this.props.history.push('/'),
        },
        {
          className: ButtonStyle.Normal,
          label: 'Get the Filtru app',
          handler: () => window.location.replace('https://getfiltru.com'),
        },
        {
          className: ButtonStyle.Normal,
          label: 'Manage Account',
          handler: () => this.props.history.push('/login'),
        },
      ]}
    />
    {props.children}
  </div>
);
